import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center-wrapper"
}
const _hoisted_2 = { class: "center-wrapper" }
const _hoisted_3 = { class: "input-inline" }
const _hoisted_4 = { class: "input-inline" }
const _hoisted_5 = { class: "input-inline" }
const _hoisted_6 = { class: "input-inline" }
const _hoisted_7 = { class: "input-inline" }
const _hoisted_8 = { class: "inline-or-block" }
const _hoisted_9 = { style: {"padding-bottom":"10px","padding-left":"10px"} }
const _hoisted_10 = { style: {"padding-left":"10px"} }
const _hoisted_11 = { class: "table-header" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { style: {"word-break":"break-all"} }
const _hoisted_17 = { style: {"word-break":"break-all"} }
const _hoisted_18 = { style: {"line-break":"anywhere"} }
const _hoisted_19 = { style: {"word-break":"break-all","min-width":"30px"} }
const _hoisted_20 = { style: {"line-break":"anywhere"} }
const _hoisted_21 = { style: {"line-break":"anywhere"} }
const _hoisted_22 = { style: {"line-break":"anywhere"} }
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JapaneseInput = _resolveComponent("JapaneseInput")!
  const _component_select_prefecture = _resolveComponent("select-prefecture")!
  const _component_select_store = _resolveComponent("select-store")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pager = _resolveComponent("pager")!
  const _component_order_history_edit = _resolveComponent("order-history-edit")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isSearchMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "inline-label" }, "顧客コード", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "form-control search-customer-code no-ime",
                type: "tel",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchReq.id) = $event)),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toHankakuCode && _ctx.toHankakuCode(...args)))
              }, null, 544), [
                [_vModelText, _ctx.searchReq.id]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "inline-label" }, "顧客名", -1)),
              _createVNode(_component_JapaneseInput, {
                class: "search-customer-name",
                modelValue: _ctx.searchReq.name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchReq.name) = $event)),
                onKeydown: _withKeys(_ctx.search, ["enter"]),
                onChange: _ctx.toHankanaWhole
              }, null, 8, ["modelValue", "onKeydown", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "inline-label" }, "電話番号", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "form-control search-customer-phoneNo no-ime",
                type: "tel",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchReq.phoneNo) = $event)),
                onKeydown: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toHankakuPhone && _ctx.toHankakuPhone(...args)))
              }, null, 544), [
                [_vModelText, _ctx.searchReq.phoneNo]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "inline-label" }, "都道府県", -1)),
              _createVNode(_component_select_prefecture, {
                prefecture: _ctx.searchReq.prefecture,
                "onUpdate:prefecture": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchReq.prefecture) = $event)),
                onKeydown: _withKeys(_ctx.search, ["enter"])
              }, null, 8, ["prefecture", "onKeydown"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { class: "inline-label" }, "担当店", -1)),
              _createVNode(_component_select_store, {
                store: _ctx.searchReq.store,
                "onUpdate:store": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchReq.store) = $event)),
                onKeydown: _withKeys(_ctx.search, ["enter"])
              }, null, 8, ["store", "onKeydown"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
              }, "検索")
            ])
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("hr", { style: {"margin":"20px 0 40px"} }, null, -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.insert && _ctx.insert(...args))),
              class: "link-button"
            }, "新規追加")
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_11, [
                  _cache[24] || (_cache[24] = _createElementVNode("th", null, null, -1)),
                  _createElementVNode("th", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "link-button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.order('customerId')))
                      }, [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("顧客", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("コード", -1)
                      ]))]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getOrderString('customerId')), 1)
                    ])
                  ]),
                  _createElementVNode("th", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "link-button",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.order('customerName')))
                      }, "顧客名"),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getOrderString('customerName')), 1)
                    ])
                  ]),
                  _createElementVNode("th", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "link-button",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.order('customerKana')))
                      }, "顧客名カナ"),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getOrderString('customerKana')), 1)
                    ])
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("th", null, [
                    _createTextVNode("郵便"),
                    _createElementVNode("br"),
                    _createTextVNode("番号")
                  ], -1)),
                  _cache[26] || (_cache[26] = _createElementVNode("th", null, "住所", -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("th", null, "電話番号", -1)),
                  _createElementVNode("th", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "link-button",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.order('orderDate')))
                      }, "注文日"),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getOrderString('orderDate')), 1)
                    ])
                  ]),
                  _createElementVNode("th", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "link-button",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.orderDest('productCode')))
                      }, "品名記号"),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getOrderDestString('productCode')), 1)
                    ])
                  ]),
                  _createElementVNode("th", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "link-button",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.orderDest('sendDate')))
                      }, "発送日"),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getOrderDestString('sendDate')), 1)
                    ])
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("th", null, "備考", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.loading && _ctx.loading.isFirstLoadFinished && _ctx.orderTable.list.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("td", {
                        colspan: "11",
                        class: "no-data"
                      }, " データがありません ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTable.list, (order) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: order.id
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "link-button edit-remove-link",
                          onClick: ($event: any) => (_ctx.edit(order))
                        }, "編集", 8, _hoisted_13),
                        _createElementVNode("button", {
                          class: "link-button edit-remove-link",
                          onClick: ($event: any) => (_ctx.remove(order))
                        }, "削除", 8, _hoisted_14)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "link-button",
                          onClick: ($event: any) => (_ctx.switchDest(order))
                        }, _toDisplayString(order.customerId), 9, _hoisted_15)
                      ]),
                      _createElementVNode("td", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          to: '/master/customer?id=' + order.customerId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(order.customerName), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(order.customerKana), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(order.customerZipCode), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$root.util.getOrderDestAddress(order)), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(order.customerPhoneNo), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$root.util.formatDate(order.orderDate)), 1),
                      _cache[30] || (_cache[30] = _createElementVNode("td", { style: {"text-align":"center"} }, "-", -1)),
                      _cache[31] || (_cache[31] = _createElementVNode("td", { style: {"text-align":"center"} }, "-", -1)),
                      _cache[32] || (_cache[32] = _createElementVNode("td", { style: {"text-align":"center"} }, "-", -1))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.destination, (dest) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass(["customer-destination", order.showDestination ? 'show-tr-animation' : 'hide-tr-animation']),
                        key: dest.id
                      }, [
                        _cache[33] || (_cache[33] = _createElementVNode("td", null, [
                          _createElementVNode("div", null, " ")
                        ], -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(dest.customerId), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_router_link, {
                              to: '/master/customer?id=' + dest.customerId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(dest.customerName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(dest.customerKana), 1)
                        ]),
                        _createElementVNode("td", _hoisted_21, [
                          _createElementVNode("div", null, _toDisplayString(dest.customerZipCode), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$root.util.getOrderDestAddress(dest)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("div", null, _toDisplayString(dest.customerPhoneNo), 1)
                        ]),
                        _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                          _createElementVNode("div", { style: {"text-align":"center"} }, "-")
                        ], -1)),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(dest.productCode), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$root.util.formatDate(dest.sendDate)), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(dest.note), 1)
                        ])
                      ], 2))
                    }), 128))
                  ], 64))
                }), 128))
              ])
            ]),
            _createVNode(_component_pager, {
              itemIndex: _ctx.searchReq.startIndex,
              itemsInPage: _ctx.searchReq.length,
              itemLength: _ctx.orderTable.allCount,
              onClickPage: _ctx.changePage
            }, null, 8, ["itemIndex", "itemsInPage", "itemLength", "onClickPage"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(_component_order_history_edit, {
            order: _ctx.editTarget,
            isInsert: _ctx.isEditInsert,
            onSaveOrder: _ctx.save
          }, null, 8, ["order", "isInsert", "onSaveOrder"]),
          _createElementVNode("button", {
            class: "link-button",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isSearchMode=true))
          }, "一覧に戻る")
        ])),
    _createVNode(_component_loading, {
      minHeight: "60px",
      ref: "loading"
    }, null, 512)
  ], 64))
}